import React, { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import FullPageDialog from '../components/FullPageDialog/FullPageDialog';
import { StudentActivityContent } from './components/StudentActivityContent/StudentActivityContent';
import StudentActivityWidget from './components/StudentActivityWidget/StudentActivityWidget';
import { useStudentActivity } from './hooks/useStudentActivity';
import { filterStudentsWithoutActivityInDays } from './utils/studentFilters';
import {
  DisableEscapeKeyDownProvider,
  useDisableEscapeKeyDown,
} from '../hooks/useDisableEscapeKeyDown';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 3,
    },
  },
});

const DAYS_THRESHOLD = 7;

function StudentActivity({ courseId, apiHost, handleISGLaunch }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { disableEscapeKeyDown } = useDisableEscapeKeyDown();

  const { data: students = [], isLoading, error } = useStudentActivity(
    apiHost,
    courseId,
  );

  const studentsWithoutActivity = filterStudentsWithoutActivityInDays(
    DAYS_THRESHOLD,
    students,
  );

  if (isLoading || error || !students) {
    return null;
  }

  return (
    <>
      <StudentActivityWidget
        studentsWithoutActivity={studentsWithoutActivity}
        daysThreshold={DAYS_THRESHOLD}
        onViewClick={() => setIsModalOpen(true)}
      />
      <FullPageDialog
        open={isModalOpen}
        setOpen={setIsModalOpen}
        title="Inactive Students"
        closeButtonTestId="activity_launch_bet_close_btn"
        disableEscapeKeyDown={disableEscapeKeyDown}
      >
        <StudentActivityContent
          students={students}
          studentsWithoutActivity={studentsWithoutActivity}
          days={DAYS_THRESHOLD}
          handleISGLaunch={handleISGLaunch}
          setOpen={setIsModalOpen}
          courseId={courseId}
          apiHost={apiHost}
        />
      </FullPageDialog>
    </>
  );
}

export function StudentActivityContainer(props) {
  return (
    <QueryClientProvider client={queryClient}>
      <DisableEscapeKeyDownProvider>
        <StudentActivity {...props} />
      </DisableEscapeKeyDownProvider>
    </QueryClientProvider>
  );
}
